module.exports = __webpack_public_path__ + "static/michal-and-przemek-049a7e846405051074bd031a16cd8a65.webp";